
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SubCentroCostosService {

    constructor(private apiService: ApiService, private http: HttpClient) { }
    
    
    //NO ESTA IMPLEMENTADO EN LA BASE DE DATOS
    buscarSubCentroCostos(tipo: any,razonc: any,dident: any,limit: any,offset: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.execGetQueryJson(`buscar?tipcli=${tipo}&razonc=${encodeURI(razonc)}&dident=${dident}&limit=${limit}&offset=${offset}`);

    }

    insertarSubCentroCostos(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarSubCentroCostos(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarSubCentroCostos(tipcli: any,codcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.executeDeleteJson(`${tipcli}/${codcli}`);
    }

    obtenerSubCentroCostos(tipcli: any,codcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.execGetQueryJson(`${tipcli}/${codcli}`)
    }

    eliminar_bancos(codcli: any, codefi: any, tipcta: any, moneda: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.executeDeleteJson(`${codcli}/bancos/${codefi}/tipo-cuenta/${tipcta}/moneda/${moneda}`);
    }

    eliminar_especificacion(codcli: any, codesp: any,tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url+`${codcli}/especificaciones/${codesp}`);
        return this.apiService.executeDeleteJson(tipcli);
    }

    eliminarClase(codcli: any, clase: any,tipcli: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url+`${codcli}/clases/${clase}`);
        return this.apiService.executeDeleteJson(`?tipcli=${tipcli}`)
    }
    buscarSubcentroCostos(codcli: string, razonc: string,
        dident: string, limit: number, offset: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url);
        return this.apiService.execGetQueryJson(`buscar?codcli=${codcli}&razonc=${encodeURIComponent(razonc)}&dident=${dident}&limit=${limit}&offset=${offset}`);
    }
    obtenerSubCentroCostos2(codcli:any,tipcli:any){
    this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.sub_centro_costos_url + `${tipcli}/${codcli}`);
    return this.apiService.execGetJson();

    }

}

